export const footerLinks = {
    'kz-ru': [
        {
            title: 'Популярные направления',
            items: [
                {
                    href: 'https://kz.wingie.com/flights/to-almaty/',
                    title: 'Алматы',
                },
                {
                    href: 'https://kz.wingie.com/flights/to-astana/',
                    title: 'Астана',
                },
                {
                    href: 'https://kz.wingie.com/flights/to-shymkent/',
                    title: 'Шымкент',
                },
                {
                    href: 'https://kz.wingie.com/flights/to-moscow/',
                    title: 'Москва',
                },
                {
                    href: 'https://kz.wingie.com/flights/to-istanbul/',
                    title: 'Стамбул',
                },
                {
                    href: 'https://kz.wingie.com/flights/to-dubai/',
                    title: 'Дубай',
                },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                {
                    href: 'https://kz.wingie.com/flights/ru-russia/',
                    title: 'Россия',
                },
                {
                    href: 'https://kz.wingie.com/flights/tr-turkey/',
                    title: 'Турция',
                },
                {
                    href: 'https://kz.wingie.com/flights/ae-united-arab-emirates/',
                    title: 'ОАЭ',
                },
                {
                    href: 'https://kz.wingie.com/flights/th-thailand/',
                    title: 'Таиланд',
                },
                {
                    href: 'https://kz.wingie.com/flights/ge-georgia/',
                    title: 'Грузия',
                },
                {
                    href: 'https://kz.wingie.com/flights/kg-kyrgyzstan/',
                    title: 'Кыргызстан',
                },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                {
                    href: 'https://kz.wingie.com/flights/airlines/air-astana/',
                    title: 'Air Astana',
                },
                {
                    href: 'https://kz.wingie.com/flights/airlines/scat-airlines/',
                    title: 'SCAT Airlines',
                },
                {
                    href: 'https://kz.wingie.com/flights/airlines/qazaq-air/',
                    title: 'Qazaq Air',
                },
                {
                    href: 'https://kz.wingie.com/flights/airlines/aeroflot/',
                    title: 'Аэрофлот',
                },
                {
                    href: 'https://kz.wingie.com/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kz.wingie.com/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kz-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    href: 'https://kz.wingie.com/en/flights/to-almaty/',
                    title: 'Almaty',
                },
                {
                    href: 'https://kz.wingie.com/en/flights/to-astana/',
                    title: 'Astana',
                },
                {
                    href: 'https://kz.wingie.com/en/flights/to-shymkent/',
                    title: 'Shymkent',
                },
                {
                    href: 'https://kz.wingie.com/en/flights/to-moscow/',
                    title: 'Moscow',
                },
                {
                    href: 'https://kz.wingie.com/en/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://kz.wingie.com/en/flights/to-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    href: 'https://kz.wingie.com/en/flights/ru-russia/',
                    title: 'Russia',
                },
                {
                    href: 'https://kz.wingie.com/en/flights/tr-turkey/',
                    title: 'Turkey',
                },
                {
                    href: 'https://kz.wingie.com/en/flights/ae-united-arab-emirates/',
                    title: 'UAE',
                },
                {
                    href: 'https://kz.wingie.com/en/flights/th-thailand/',
                    title: 'Thailand',
                },
                {
                    href: 'https://kz.wingie.com/en/flights/ge-georgia/',
                    title: 'Georgia',
                },
                {
                    href: 'https://kz.wingie.com/en/flights/kg-kyrgyzstan/',
                    title: 'Kyrgyzstan',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    href: 'https://kz.wingie.com/en/flights/airlines/air-astana/',
                    title: 'Air Astana',
                },
                {
                    href: 'https://kz.wingie.com/en/flights/airlines/scat-airlines/',
                    title: 'SCAT Airlines',
                },
                {
                    href: 'https://kz.wingie.com/en/flights/airlines/qazaq-air/',
                    title: 'Qazaq Air',
                },
                {
                    href: 'https://kz.wingie.com/en/flights/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kz.wingie.com/en/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kz.wingie.com/en/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kz-es': [
        {
            title: 'Destinos principales',
            items: [
                {
                    href: 'https://kz.wingie.com/es/vuelos/a-almaty/',
                    title: 'Almaty',
                },
                {
                    href: 'https://kz.wingie.com/es/vuelos/a-astana/',
                    title: 'Astana',
                },
                {
                    href: 'https://kz.wingie.com/es/vuelos/a-shymkent/',
                    title: 'Shymkent',
                },
                {
                    href: 'https://kz.wingie.com/es/vuelos/a-moscu/',
                    title: 'Moscú',
                },
                {
                    href: 'https://kz.wingie.com/es/vuelos/a-estambul/',
                    title: 'Estambul',
                },
                {
                    href: 'https://kz.wingie.com/es/vuelos/a-dubai/',
                    title: 'Dubái',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    href: 'https://kz.wingie.com/es/vuelos/ru-rusia/',
                    title: 'Rusia',
                },
                {
                    href: 'https://kz.wingie.com/es/vuelos/tr-turquia/',
                    title: 'Turquía',
                },
                {
                    href: 'https://kz.wingie.com/es/vuelos/ae-emiratos-arabes-unidos/',
                    title: 'Emiratos Árabes Unidos',
                },
                {
                    href: 'https://kz.wingie.com/es/vuelos/th-tailandia/',
                    title: 'Tailandia',
                },
                {
                    href: 'https://kz.wingie.com/es/vuelos/ge-georgia/',
                    title: 'Georgia',
                },
                {
                    href: 'https://kz.wingie.com/es/vuelos/kg-kirguistan/',
                    title: 'Kirguistán',
                },
            ],
        },
        {
            title: 'Aerolíneas populares',
            items: [
                {
                    href: 'https://kz.wingie.com/es/vuelos/companias-aereas/air-astana/',
                    title: 'Air Astana',
                },
                {
                    href: 'https://kz.wingie.com/es/vuelos/companias-aereas/scat-airlines/',
                    title: 'SCAT Airlines',
                },
                {
                    href: 'https://kz.wingie.com/es/vuelos/companias-aereas/qazaq-air/',
                    title: 'Qazaq Air',
                },
                {
                    href: 'https://kz.wingie.com/es/vuelos/companias-aereas/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kz.wingie.com/es/vuelos/companias-aereas/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kz.wingie.com/es/vuelos/companias-aereas/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kz-de': [
        {
            title: 'Top-Reiseziele',
            items: [
                {
                    href: 'https://kz.wingie.com/de/flug/nach-almaty/',
                    title: 'Almaty',
                },
                {
                    href: 'https://kz.wingie.com/de/flug/nach-astana/',
                    title: 'Astana',
                },
                {
                    href: 'https://kz.wingie.com/de/flug/nach-schymkent/',
                    title: 'Schymkent',
                },
                {
                    href: 'https://kz.wingie.com/de/flug/nach-moskau/',
                    title: 'Moskau',
                },
                {
                    href: 'https://kz.wingie.com/de/flug/nach-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://kz.wingie.com/de/flug/nach-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://kz.wingie.com/de/flug/ru-russland/',
                    title: 'Russland',
                },
                {
                    href: 'https://kz.wingie.com/de/flug/tr-turkei/',
                    title: 'Türkei',
                },
                {
                    href: 'https://kz.wingie.com/de/flug/ae-vereinigte-arabische-emirate/',
                    title: 'Vereinigte Arabische Emirate',
                },
                {
                    href: 'https://kz.wingie.com/de/flug/th-thailand/',
                    title: 'Thailand',
                },
                {
                    href: 'https://kz.wingie.com/de/flug/ge-georgien/',
                    title: 'Georgien',
                },
                {
                    href: 'https://kz.wingie.com/de/flug/kg-kirgisistan/',
                    title: 'Kirgisistan',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://kz.wingie.com/de/flug/airlines/air-astana/',
                    title: 'Air Astana',
                },
                {
                    href: 'https://kz.wingie.com/de/flug/airlines/scat-airlines/',
                    title: 'SCAT Airlines',
                },
                {
                    href: 'https://kz.wingie.com/de/flug/airlines/qazaq-air/',
                    title: 'Qazaq Air',
                },
                {
                    href: 'https://kz.wingie.com/de/flug/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kz.wingie.com/de/flug/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kz.wingie.com/de/flug/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kz-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://kz.wingie.com/ar/flights/to-almaty/',
                    title: 'ألماتي',
                },
                {
                    href: 'https://kz.wingie.com/ar/flights/to-astana/',
                    title: 'أستانا',
                },
                {
                    href: 'https://kz.wingie.com/ar/flights/to-shymkent/',
                    title: 'شيمكنت',
                },
                {
                    href: 'https://kz.wingie.com/ar/flights/to-moscow/',
                    title: 'موسكو',
                },
                {
                    href: 'https://kz.wingie.com/ar/flights/to-istanbul/',
                    title: 'إسطنبول',
                },
                {
                    href: 'https://kz.wingie.com/ar/flights/to-dubai/',
                    title: 'دبي',
                },
            ],
        },
        {
            title: 'الدول الشعبية',
            items: [
                {
                    href: 'https://kz.wingie.com/ar/flights/ru-russia/',
                    title: 'روسيا',
                },
                {
                    href: 'https://kz.wingie.com/ar/flights/tr-turkey/',
                    title: 'تركيا',
                },
                {
                    href: 'https://kz.wingie.com/ar/flights/ae-united-arab-emirates/',
                    title: 'الإمارات العربية المتحدة',
                },
                {
                    href: 'https://kz.wingie.com/ar/flights/th-thailand/',
                    title: 'تايلاند',
                },
                {
                    href: 'https://kz.wingie.com/ar/flights/ge-georgia/',
                    title: 'جورجيا',
                },
                {
                    href: 'https://kz.wingie.com/ar/flights/kg-kyrgyzstan/',
                    title: 'قيرغيزستان',
                },
            ],
        },
        {
            title: 'شركات الطيران الشعبية',
            items: [
                {
                    href: 'https://kz.wingie.com/ar/flights/airlines/air-astana/',
                    title: 'طيران آستانا',
                },
                {
                    href: 'https://kz.wingie.com/ar/flights/airlines/scat-airlines/',
                    title: 'طيران سكات',
                },
                {
                    href: 'https://kz.wingie.com/ar/flights/airlines/qazaq-air/',
                    title: 'طيران قازاق',
                },
                {
                    href: 'https://kz.wingie.com/ar/flights/airlines/aeroflot/',
                    title: 'أيروفلوت',
                },
                {
                    href: 'https://kz.wingie.com/ar/flights/airlines/turkish-airlines/',
                    title: 'الخطوط الجوية التركية',
                },
                {
                    href: 'https://kz.wingie.com/ar/flights/airlines/fly-dubai/',
                    title: 'فلاي دبي',
                },
            ],
        },
    ],
    'kz-it': [
        {
            title: 'Destinazioni Top',
            items: [
                {
                    href: 'https://kz.wingie.com/it/flights/to-almaty/',
                    title: 'Almaty',
                },
                {
                    href: 'https://kz.wingie.com/it/flights/to-astana/',
                    title: 'Astana',
                },
                {
                    href: 'https://kz.wingie.com/it/flights/to-shymkent/',
                    title: 'Shymkent',
                },
                {
                    href: 'https://kz.wingie.com/it/flights/to-moscow/',
                    title: 'Mosca',
                },
                {
                    href: 'https://kz.wingie.com/it/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://kz.wingie.com/it/flights/to-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Paesi Popolari',
            items: [
                {
                    href: 'https://kz.wingie.com/it/flights/ru-russia/',
                    title: 'Russia',
                },
                {
                    href: 'https://kz.wingie.com/it/flights/tr-turkey/',
                    title: 'Turchia',
                },
                {
                    href: 'https://kz.wingie.com/it/flights/ae-united-arab-emirates/',
                    title: 'Emirati Arabi Uniti',
                },
                {
                    href: 'https://kz.wingie.com/it/flights/th-thailand/',
                    title: 'Tailandia',
                },
                {
                    href: 'https://kz.wingie.com/it/flights/ge-georgia/',
                    title: 'Georgia',
                },
                {
                    href: 'https://kz.wingie.com/it/flights/kg-kyrgyzstan/',
                    title: 'Kirghizistan',
                },
            ],
        },
        {
            title: 'Compagnie Aeree Popolari',
            items: [
                {
                    href: 'https://kz.wingie.com/it/flights/airlines/air-astana/',
                    title: 'Air Astana',
                },
                {
                    href: 'https://kz.wingie.com/it/flights/airlines/scat-airlines/',
                    title: 'SCAT Airlines',
                },
                {
                    href: 'https://kz.wingie.com/it/flights/airlines/qazaq-air/',
                    title: 'Qazaq Air',
                },
                {
                    href: 'https://kz.wingie.com/it/flights/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kz.wingie.com/it/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kz.wingie.com/it/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kz-fr': [
        {
            title: 'Meilleures Destinations',
            items: [
                {
                    href: 'https://kz.wingie.com/fr/flights/to-almaty/',
                    title: 'Almaty',
                },
                {
                    href: 'https://kz.wingie.com/fr/flights/to-astana/',
                    title: 'Astana',
                },
                {
                    href: 'https://kz.wingie.com/fr/flights/to-shymkent/',
                    title: 'Shymkent',
                },
                {
                    href: 'https://kz.wingie.com/fr/flights/to-moscow/',
                    title: 'Moscou',
                },
                {
                    href: 'https://kz.wingie.com/fr/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://kz.wingie.com/fr/flights/to-dubai/',
                    title: 'Dubaï',
                },
            ],
        },
        {
            title: 'Pays Populaires',
            items: [
                {
                    href: 'https://kz.wingie.com/fr/flights/ru-russia/',
                    title: 'Russie',
                },
                {
                    href: 'https://kz.wingie.com/fr/flights/tr-turkey/',
                    title: 'Turquie',
                },
                {
                    href: 'https://kz.wingie.com/fr/flights/ae-united-arab-emirates/',
                    title: 'Émirats Arabes Unis',
                },
                {
                    href: 'https://kz.wingie.com/fr/flights/th-thailand/',
                    title: 'Thaïlande',
                },
                {
                    href: 'https://kz.wingie.com/fr/flights/ge-georgia/',
                    title: 'Géorgie',
                },
                {
                    href: 'https://kz.wingie.com/fr/flights/kg-kyrgyzstan/',
                    title: 'Kirghizistan',
                },
            ],
        },
        {
            title: 'Compagnies Aériennes Populaires',
            items: [
                {
                    href: 'https://kz.wingie.com/fr/flights/airlines/air-astana/',
                    title: 'Air Astana',
                },
                {
                    href: 'https://kz.wingie.com/fr/flights/airlines/scat-airlines/',
                    title: 'SCAT Airlines',
                },
                {
                    href: 'https://kz.wingie.com/fr/flights/airlines/qazaq-air/',
                    title: 'Qazaq Air',
                },
                {
                    href: 'https://kz.wingie.com/fr/flights/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kz.wingie.com/fr/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kz.wingie.com/fr/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kz-pt': [
        {
            title: 'Principais Destinos',
            items: [
                {
                    href: 'https://kz.wingie.com/pt/flights/to-almaty/',
                    title: 'Almaty',
                },
                {
                    href: 'https://kz.wingie.com/pt/flights/to-astana/',
                    title: 'Astana',
                },
                {
                    href: 'https://kz.wingie.com/pt/flights/to-shymkent/',
                    title: 'Shymkent',
                },
                {
                    href: 'https://kz.wingie.com/pt/flights/to-moscow/',
                    title: 'Moscovo',
                },
                {
                    href: 'https://kz.wingie.com/pt/flights/to-istanbul/',
                    title: 'Istambul',
                },
                {
                    href: 'https://kz.wingie.com/pt/flights/to-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Países Populares',
            items: [
                {
                    href: 'https://kz.wingie.com/pt/flights/ru-russia/',
                    title: 'Rússia',
                },
                {
                    href: 'https://kz.wingie.com/pt/flights/tr-turkey/',
                    title: 'Turquia',
                },
                {
                    href: 'https://kz.wingie.com/pt/flights/ae-united-arab-emirates/',
                    title: 'Emirados Árabes Unidos',
                },
                {
                    href: 'https://kz.wingie.com/pt/flights/th-thailand/',
                    title: 'Tailândia',
                },
                {
                    href: 'https://kz.wingie.com/pt/flights/ge-georgia/',
                    title: 'Geórgia',
                },
                {
                    href: 'https://kz.wingie.com/pt/flights/kg-kyrgyzstan/',
                    title: 'Quirguistão',
                },
            ],
        },
        {
            title: 'Companhias Aéreas Populares',
            items: [
                {
                    href: 'https://kz.wingie.com/pt/flights/airlines/air-astana/',
                    title: 'Air Astana',
                },
                {
                    href: 'https://kz.wingie.com/pt/flights/airlines/scat-airlines/',
                    title: 'SCAT Airlines',
                },
                {
                    href: 'https://kz.wingie.com/pt/flights/airlines/qazaq-air/',
                    title: 'Qazaq Air',
                },
                {
                    href: 'https://kz.wingie.com/pt/flights/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kz.wingie.com/pt/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kz.wingie.com/pt/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kz-ro': [
        {
            title: 'Destinații de Top',
            items: [
                {
                    href: 'https://kz.wingie.com/ro/flights/to-almaty/',
                    title: 'Almaty',
                },
                {
                    href: 'https://kz.wingie.com/ro/flights/to-astana/',
                    title: 'Astana',
                },
                {
                    href: 'https://kz.wingie.com/ro/flights/to-shymkent/',
                    title: 'Shymkent',
                },
                {
                    href: 'https://kz.wingie.com/ro/flights/to-moscow/',
                    title: 'Moscova',
                },
                {
                    href: 'https://kz.wingie.com/ro/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://kz.wingie.com/ro/flights/to-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Țări Populare',
            items: [
                {
                    href: 'https://kz.wingie.com/ro/flights/ru-russia/',
                    title: 'Rusia',
                },
                {
                    href: 'https://kz.wingie.com/ro/flights/tr-turkey/',
                    title: 'Turcia',
                },
                {
                    href: 'https://kz.wingie.com/ro/flights/ae-united-arab-emirates/',
                    title: 'Emiratele Arabe Unite',
                },
                {
                    href: 'https://kz.wingie.com/ro/flights/th-thailand/',
                    title: 'Thailanda',
                },
                {
                    href: 'https://kz.wingie.com/ro/flights/ge-georgia/',
                    title: 'Georgia',
                },
                {
                    href: 'https://kz.wingie.com/ro/flights/kg-kyrgyzstan/',
                    title: 'Kârgâzstan',
                },
            ],
        },
        {
            title: 'Companii Aeriene Populare',
            items: [
                {
                    href: 'https://kz.wingie.com/ro/flights/airlines/air-astana/',
                    title: 'Air Astana',
                },
                {
                    href: 'https://kz.wingie.com/ro/flights/airlines/scat-airlines/',
                    title: 'SCAT Airlines',
                },
                {
                    href: 'https://kz.wingie.com/ro/flights/airlines/qazaq-air/',
                    title: 'Qazaq Air',
                },
                {
                    href: 'https://kz.wingie.com/ro/flights/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kz.wingie.com/ro/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kz.wingie.com/ro/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kz-pl': [
        {
            title: 'Najlepsze Destynacje',
            items: [
                {
                    href: 'https://kz.wingie.com/pl/flights/to-almaty/',
                    title: 'Ałmaty',
                },
                {
                    href: 'https://kz.wingie.com/pl/flights/to-astana/',
                    title: 'Astana',
                },
                {
                    href: 'https://kz.wingie.com/pl/flights/to-shymkent/',
                    title: 'Szymkent',
                },
                {
                    href: 'https://kz.wingie.com/pl/flights/to-moscow/',
                    title: 'Moskwa',
                },
                {
                    href: 'https://kz.wingie.com/pl/flights/to-istanbul/',
                    title: 'Stambuł',
                },
                {
                    href: 'https://kz.wingie.com/pl/flights/to-dubai/',
                    title: 'Dubaj',
                },
            ],
        },
        {
            title: 'Popularne Kraje',
            items: [
                {
                    href: 'https://kz.wingie.com/pl/flights/ru-russia/',
                    title: 'Rosja',
                },
                {
                    href: 'https://kz.wingie.com/pl/flights/tr-turkey/',
                    title: 'Turcja',
                },
                {
                    href: 'https://kz.wingie.com/pl/flights/ae-united-arab-emirates/',
                    title: 'Zjednoczone Emiraty Arabskie',
                },
                {
                    href: 'https://kz.wingie.com/pl/flights/th-thailand/',
                    title: 'Tajlandia',
                },
                {
                    href: 'https://kz.wingie.com/pl/flights/ge-georgia/',
                    title: 'Gruzja',
                },
                {
                    href: 'https://kz.wingie.com/pl/flights/kg-kyrgyzstan/',
                    title: 'Kirgistan',
                },
            ],
        },
        {
            title: 'Popularne Linie Lotnicze',
            items: [
                {
                    href: 'https://kz.wingie.com/pl/flights/airlines/air-astana/',
                    title: 'Air Astana',
                },
                {
                    href: 'https://kz.wingie.com/pl/flights/airlines/scat-airlines/',
                    title: 'SCAT Airlines',
                },
                {
                    href: 'https://kz.wingie.com/pl/flights/airlines/qazaq-air/',
                    title: 'Qazaq Air',
                },
                {
                    href: 'https://kz.wingie.com/pl/flights/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kz.wingie.com/pl/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kz.wingie.com/pl/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kz-lt': [
        {
            title: 'Populiariausi Miestai',
            items: [
                {
                    href: 'https://kz.wingie.com/lt/flights/to-almaty/',
                    title: 'Almata',
                },
                {
                    href: 'https://kz.wingie.com/lt/flights/to-astana/',
                    title: 'Astana',
                },
                {
                    href: 'https://kz.wingie.com/lt/flights/to-shymkent/',
                    title: 'Šymkentas',
                },
                {
                    href: 'https://kz.wingie.com/lt/flights/to-moscow/',
                    title: 'Maskva',
                },
                {
                    href: 'https://kz.wingie.com/lt/flights/to-istanbul/',
                    title: 'Stambulas',
                },
                {
                    href: 'https://kz.wingie.com/lt/flights/to-dubai/',
                    title: 'Dubajus',
                },
            ],
        },
        {
            title: 'Populiarios Šalys',
            items: [
                {
                    href: 'https://kz.wingie.com/lt/flights/ru-russia/',
                    title: 'Rusija',
                },
                {
                    href: 'https://kz.wingie.com/lt/flights/tr-turkey/',
                    title: 'Turkija',
                },
                {
                    href: 'https://kz.wingie.com/lt/flights/ae-united-arab-emirates/',
                    title: 'Jungtiniai Arabų Emyratai',
                },
                {
                    href: 'https://kz.wingie.com/lt/flights/th-thailand/',
                    title: 'Tailandas',
                },
                {
                    href: 'https://kz.wingie.com/lt/flights/ge-georgia/',
                    title: 'Gruzija',
                },
                {
                    href: 'https://kz.wingie.com/lt/flights/kg-kyrgyzstan/',
                    title: 'Kirgizija',
                },
            ],
        },
        {
            title: 'Populiarios Oro Linijos',
            items: [
                {
                    href: 'https://kz.wingie.com/lt/flights/airlines/air-astana/',
                    title: 'Air Astana',
                },
                {
                    href: 'https://kz.wingie.com/lt/flights/airlines/scat-airlines/',
                    title: 'SCAT Airlines',
                },
                {
                    href: 'https://kz.wingie.com/lt/flights/airlines/qazaq-air/',
                    title: 'Qazaq Air',
                },
                {
                    href: 'https://kz.wingie.com/lt/flights/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kz.wingie.com/lt/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kz.wingie.com/lt/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kz-uz': [
        {
            title: 'Eng Mashhur Shaharlar',
            items: [
                {
                    href: 'https://kz.wingie.com/uz/flights/to-almaty/',
                    title: 'Olmati',
                },
                {
                    href: 'https://kz.wingie.com/uz/flights/to-astana/',
                    title: 'Astana',
                },
                {
                    href: 'https://kz.wingie.com/uz/flights/to-shymkent/',
                    title: 'Shimkent',
                },
                {
                    href: 'https://kz.wingie.com/uz/flights/to-moscow/',
                    title: 'Moskva',
                },
                {
                    href: 'https://kz.wingie.com/uz/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://kz.wingie.com/uz/flights/to-dubai/',
                    title: 'Dubay',
                },
            ],
        },
        {
            title: 'Mashhur Davlatlar',
            items: [
                {
                    href: 'https://kz.wingie.com/uz/flights/ru-russia/',
                    title: 'Rossiya',
                },
                {
                    href: 'https://kz.wingie.com/uz/flights/tr-turkey/',
                    title: 'Turkiya',
                },
                {
                    href: 'https://kz.wingie.com/uz/flights/ae-united-arab-emirates/',
                    title: 'Birlashgan Arab Amirliklari',
                },
                {
                    href: 'https://kz.wingie.com/uz/flights/th-thailand/',
                    title: 'Tailand',
                },
                {
                    href: 'https://kz.wingie.com/uz/flights/ge-georgia/',
                    title: 'Gruziya',
                },
                {
                    href: 'https://kz.wingie.com/uz/flights/kg-kyrgyzstan/',
                    title: "Qirg'iziston",
                },
            ],
        },
        {
            title: 'Mashhur Aviakompaniyalar',
            items: [
                {
                    href: 'https://kz.wingie.com/uz/flights/airlines/air-astana/',
                    title: 'Air Astana',
                },
                {
                    href: 'https://kz.wingie.com/uz/flights/airlines/scat-airlines/',
                    title: 'SCAT Airlines',
                },
                {
                    href: 'https://kz.wingie.com/uz/flights/airlines/qazaq-air/',
                    title: 'Qazaq Air',
                },
                {
                    href: 'https://kz.wingie.com/uz/flights/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kz.wingie.com/uz/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kz.wingie.com/uz/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kz-sr': [
        {
            title: 'Најпопуларније дестинације',
            items: [
                {
                    href: 'https://kz.wingie.com/sr/flights/to-almaty/',
                    title: 'Алмати',
                },
                {
                    href: 'https://kz.wingie.com/sr/flights/to-astana/',
                    title: 'Астана',
                },
                {
                    href: 'https://kz.wingie.com/sr/flights/to-shymkent/',
                    title: 'Шимкент',
                },
                {
                    href: 'https://kz.wingie.com/sr/flights/to-moscow/',
                    title: 'Москва',
                },
                {
                    href: 'https://kz.wingie.com/sr/flights/to-istanbul/',
                    title: 'Истанбул',
                },
                {
                    href: 'https://kz.wingie.com/sr/flights/to-dubai/',
                    title: 'Дубаи',
                },
            ],
        },
        {
            title: 'Популарне земље',
            items: [
                {
                    href: 'https://kz.wingie.com/sr/flights/ru-russia/',
                    title: 'Русија',
                },
                {
                    href: 'https://kz.wingie.com/sr/flights/tr-turkey/',
                    title: 'Турска',
                },
                {
                    href: 'https://kz.wingie.com/sr/flights/ae-united-arab-emirates/',
                    title: 'Уједињени Арапски Емирати',
                },
                {
                    href: 'https://kz.wingie.com/sr/flights/th-thailand/',
                    title: 'Тајланд',
                },
                {
                    href: 'https://kz.wingie.com/sr/flights/ge-georgia/',
                    title: 'Грузија',
                },
                {
                    href: 'https://kz.wingie.com/sr/flights/kg-kyrgyzstan/',
                    title: 'Киргистан',
                },
            ],
        },
        {
            title: 'Популарне авиокомпаније',
            items: [
                {
                    href: 'https://kz.wingie.com/sr/flights/airlines/air-astana/',
                    title: 'Air Astana',
                },
                {
                    href: 'https://kz.wingie.com/sr/flights/airlines/scat-airlines/',
                    title: 'SCAT Airlines',
                },
                {
                    href: 'https://kz.wingie.com/sr/flights/airlines/qazaq-air/',
                    title: 'Qazaq Air',
                },
                {
                    href: 'https://kz.wingie.com/sr/flights/airlines/aeroflot/',
                    title: 'Аерофлот',
                },
                {
                    href: 'https://kz.wingie.com/sr/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kz.wingie.com/sr/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kz-ky': [
        {
            title: 'Эң популярдуу шаарлар',
            items: [
                {
                    href: 'https://kz.wingie.com/ky/flights/to-almaty/',
                    title: 'Алматы',
                },
                {
                    href: 'https://kz.wingie.com/ky/flights/to-astana/',
                    title: 'Астана',
                },
                {
                    href: 'https://kz.wingie.com/ky/flights/to-shymkent/',
                    title: 'Шымкент',
                },
                {
                    href: 'https://kz.wingie.com/ky/flights/to-moscow/',
                    title: 'Москва',
                },
                {
                    href: 'https://kz.wingie.com/ky/flights/to-istanbul/',
                    title: 'Стамбул',
                },
                {
                    href: 'https://kz.wingie.com/ky/flights/to-dubai/',
                    title: 'Дубай',
                },
            ],
        },
        {
            title: 'Популярдуу өлкөлөр',
            items: [
                {
                    href: 'https://kz.wingie.com/ky/flights/ru-russia/',
                    title: 'Орусия',
                },
                {
                    href: 'https://kz.wingie.com/ky/flights/tr-turkey/',
                    title: 'Түркия',
                },
                {
                    href: 'https://kz.wingie.com/ky/flights/ae-united-arab-emirates/',
                    title: 'Бириккен Араб Эмираттары',
                },
                {
                    href: 'https://kz.wingie.com/ky/flights/th-thailand/',
                    title: 'Тайланд',
                },
                {
                    href: 'https://kz.wingie.com/ky/flights/ge-georgia/',
                    title: 'Грузия',
                },
                {
                    href: 'https://kz.wingie.com/ky/flights/kg-kyrgyzstan/',
                    title: 'Кыргызстан',
                },
            ],
        },
        {
            title: 'Популярдуу авиакомпаниялар',
            items: [
                {
                    href: 'https://kz.wingie.com/ky/flights/airlines/air-astana/',
                    title: 'Air Astana',
                },
                {
                    href: 'https://kz.wingie.com/ky/flights/airlines/scat-airlines/',
                    title: 'SCAT Airlines',
                },
                {
                    href: 'https://kz.wingie.com/ky/flights/airlines/qazaq-air/',
                    title: 'Qazaq Air',
                },
                {
                    href: 'https://kz.wingie.com/ky/flights/airlines/aeroflot/',
                    title: 'Аэрофлот',
                },
                {
                    href: 'https://kz.wingie.com/ky/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kz.wingie.com/ky/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kz-tg': [
        {
            title: 'Шаҳрҳои машҳур',
            items: [
                {
                    href: 'https://kz.wingie.com/tg/flights/to-almaty/',
                    title: 'Алмати',
                },
                {
                    href: 'https://kz.wingie.com/tg/flights/to-astana/',
                    title: 'Астана',
                },
                {
                    href: 'https://kz.wingie.com/tg/flights/to-shymkent/',
                    title: 'Шимкент',
                },
                {
                    href: 'https://kz.wingie.com/tg/flights/to-moscow/',
                    title: 'Маскав',
                },
                {
                    href: 'https://kz.wingie.com/tg/flights/to-istanbul/',
                    title: 'Истанбул',
                },
                {
                    href: 'https://kz.wingie.com/tg/flights/to-dubai/',
                    title: 'Дубай',
                },
            ],
        },
        {
            title: 'Кишварҳои машҳур',
            items: [
                {
                    href: 'https://kz.wingie.com/tg/flights/ru-russia/',
                    title: 'Русия',
                },
                {
                    href: 'https://kz.wingie.com/tg/flights/tr-turkey/',
                    title: 'Туркия',
                },
                {
                    href: 'https://kz.wingie.com/tg/flights/ae-united-arab-emirates/',
                    title: 'Иморотҳои Муттаҳидаи Араб',
                },
                {
                    href: 'https://kz.wingie.com/tg/flights/th-thailand/',
                    title: 'Тайланд',
                },
                {
                    href: 'https://kz.wingie.com/tg/flights/ge-georgia/',
                    title: 'Гурҷистон',
                },
                {
                    href: 'https://kz.wingie.com/tg/flights/kg-kyrgyzstan/',
                    title: 'Қирғизистон',
                },
            ],
        },
        {
            title: 'Ширкатҳои машҳури авиатсионӣ',
            items: [
                {
                    href: 'https://kz.wingie.com/tg/flights/airlines/air-astana/',
                    title: 'Air Astana',
                },
                {
                    href: 'https://kz.wingie.com/tg/flights/airlines/scat-airlines/',
                    title: 'SCAT Airlines',
                },
                {
                    href: 'https://kz.wingie.com/tg/flights/airlines/qazaq-air/',
                    title: 'Qazaq Air',
                },
                {
                    href: 'https://kz.wingie.com/tg/flights/airlines/aeroflot/',
                    title: 'Аерофлот',
                },
                {
                    href: 'https://kz.wingie.com/tg/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kz.wingie.com/tg/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kz-kk': [
        {
            title: 'Танымал бағыттар',
            items: [
                {
                    href: 'https://kz.wingie.com/kk/flights/to-almaty/',
                    title: 'Алматы',
                },
                {
                    href: 'https://kz.wingie.com/kk/flights/to-astana/',
                    title: 'Астана',
                },
                {
                    href: 'https://kz.wingie.com/kk/flights/to-shymkent/',
                    title: 'Шымкент',
                },
                {
                    href: 'https://kz.wingie.com/kk/flights/to-moscow/',
                    title: 'Мәскеу',
                },
                {
                    href: 'https://kz.wingie.com/kk/flights/to-istanbul/',
                    title: 'Стамбул',
                },
                {
                    href: 'https://kz.wingie.com/kk/flights/to-dubai/',
                    title: 'Дубай',
                },
            ],
        },
        {
            title: 'Танымал елдер',
            items: [
                {
                    href: 'https://kz.wingie.com/kk/flights/ru-russia/',
                    title: 'Ресей',
                },
                {
                    href: 'https://kz.wingie.com/kk/flights/tr-turkey/',
                    title: 'Түркия',
                },
                {
                    href: 'https://kz.wingie.com/kk/flights/ae-united-arab-emirates/',
                    title: 'Біріккен Араб Әмірліктері',
                },
                {
                    href: 'https://kz.wingie.com/kk/flights/th-thailand/',
                    title: 'Тайланд',
                },
                {
                    href: 'https://kz.wingie.com/kk/flights/ge-georgia/',
                    title: 'Грузия',
                },
                {
                    href: 'https://kz.wingie.com/kk/flights/kg-kyrgyzstan/',
                    title: 'Қырғызстан',
                },
            ],
        },
        {
            title: 'Танымал авиакомпаниялар',
            items: [
                {
                    href: 'https://kz.wingie.com/kk/flights/airlines/air-astana/',
                    title: 'Air Astana',
                },
                {
                    href: 'https://kz.wingie.com/kk/flights/airlines/scat-airlines/',
                    title: 'SCAT Airlines',
                },
                {
                    href: 'https://kz.wingie.com/kk/flights/airlines/qazaq-air/',
                    title: 'Qazaq Air',
                },
                {
                    href: 'https://kz.wingie.com/kk/flights/airlines/aeroflot/',
                    title: 'Аэрофлот',
                },
                {
                    href: 'https://kz.wingie.com/kk/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kz.wingie.com/kk/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kz-nl': [
        {
            title: 'Top Bestemmingen',
            items: [
                {
                    href: 'https://kz.wingie.com/nl/flights/to-almaty/',
                    title: 'Almaty',
                },
                {
                    href: 'https://kz.wingie.com/nl/flights/to-astana/',
                    title: 'Astana',
                },
                {
                    href: 'https://kz.wingie.com/nl/flights/to-shymkent/',
                    title: 'Shymkent',
                },
                {
                    href: 'https://kz.wingie.com/nl/flights/to-moscow/',
                    title: 'Moskou',
                },
                {
                    href: 'https://kz.wingie.com/nl/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://kz.wingie.com/nl/flights/to-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Populaire Landen',
            items: [
                {
                    href: 'https://kz.wingie.com/nl/flights/ru-russia/',
                    title: 'Rusland',
                },
                {
                    href: 'https://kz.wingie.com/nl/flights/tr-turkey/',
                    title: 'Turkije',
                },
                {
                    href: 'https://kz.wingie.com/nl/flights/ae-united-arab-emirates/',
                    title: 'Verenigde Arabische Emiraten',
                },
                {
                    href: 'https://kz.wingie.com/nl/flights/th-thailand/',
                    title: 'Thailand',
                },
                {
                    href: 'https://kz.wingie.com/nl/flights/ge-georgia/',
                    title: 'Georgië',
                },
                {
                    href: 'https://kz.wingie.com/nl/flights/kg-kyrgyzstan/',
                    title: 'Kirgizië',
                },
            ],
        },
        {
            title: 'Populaire Luchtvaartmaatschappijen',
            items: [
                {
                    href: 'https://kz.wingie.com/nl/flights/airlines/air-astana/',
                    title: 'Air Astana',
                },
                {
                    href: 'https://kz.wingie.com/nl/flights/airlines/scat-airlines/',
                    title: 'SCAT Airlines',
                },
                {
                    href: 'https://kz.wingie.com/nl/flights/airlines/qazaq-air/',
                    title: 'Qazaq Air',
                },
                {
                    href: 'https://kz.wingie.com/nl/flights/airlines/aeroflot/',
                    title: 'Aeroflot',
                },
                {
                    href: 'https://kz.wingie.com/nl/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://kz.wingie.com/nl/flights/airlines/fly-dubai/',
                    title: 'flydubai',
                },
            ],
        },
    ],
    'kz-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://kz.wingie.com/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://kz.wingie.com/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://kz.wingie.com/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://kz.wingie.com/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://kz.wingie.com/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://kz.wingie.com/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://kz.wingie.com/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://kz.wingie.com/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://kz.wingie.com/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://kz.wingie.com/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://kz.wingie.com/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://kz.wingie.com/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://kz.wingie.com/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://kz.wingie.com/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://kz.wingie.com/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://kz.wingie.com/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://kz.wingie.com/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://kz.wingie.com/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'kz-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://kz.wingie.com/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://kz.wingie.com/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://kz.wingie.com/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://kz.wingie.com/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://kz.wingie.com/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://kz.wingie.com/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://kz.wingie.com/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://kz.wingie.com/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://kz.wingie.com/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://kz.wingie.com/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://kz.wingie.com/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://kz.wingie.com/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://kz.wingie.com/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://kz.wingie.com/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://kz.wingie.com/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://kz.wingie.com/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://kz.wingie.com/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://kz.wingie.com/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'kz-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://kz.wingie.com/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://kz.wingie.com/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://kz.wingie.com/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://kz.wingie.com/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://kz.wingie.com/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://kz.wingie.com/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://kz.wingie.com/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://kz.wingie.com/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://kz.wingie.com/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://kz.wingie.com/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://kz.wingie.com/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://kz.wingie.com/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://kz.wingie.com/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://kz.wingie.com/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://kz.wingie.com/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://kz.wingie.com/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://kz.wingie.com/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://kz.wingie.com/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'kz-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://kz.wingie.com/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://kz.wingie.com/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://kz.wingie.com/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://kz.wingie.com/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://kz.wingie.com/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://kz.wingie.com/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://kz.wingie.com/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://kz.wingie.com/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://kz.wingie.com/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://kz.wingie.com/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://kz.wingie.com/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://kz.wingie.com/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://kz.wingie.com/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://kz.wingie.com/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://kz.wingie.com/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://kz.wingie.com/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://kz.wingie.com/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://kz.wingie.com/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'kz-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://kz.wingie.com/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://kz.wingie.com/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://kz.wingie.com/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://kz.wingie.com/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://kz.wingie.com/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://kz.wingie.com/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://kz.wingie.com/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://kz.wingie.com/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://kz.wingie.com/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://kz.wingie.com/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://kz.wingie.com/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://kz.wingie.com/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://kz.wingie.com/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://kz.wingie.com/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://kz.wingie.com/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://kz.wingie.com/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://kz.wingie.com/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://kz.wingie.com/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'kz-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://kz.wingie.com/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://kz.wingie.com/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://kz.wingie.com/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://kz.wingie.com/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://kz.wingie.com/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://kz.wingie.com/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://kz.wingie.com/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://kz.wingie.com/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://kz.wingie.com/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://kz.wingie.com/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://kz.wingie.com/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://kz.wingie.com/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://kz.wingie.com/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://kz.wingie.com/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://kz.wingie.com/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://kz.wingie.com/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://kz.wingie.com/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://kz.wingie.com/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'kz-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://kz.wingie.com/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://kz.wingie.com/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://kz.wingie.com/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://kz.wingie.com/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://kz.wingie.com/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://kz.wingie.com/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://kz.wingie.com/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://kz.wingie.com/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://kz.wingie.com/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://kz.wingie.com/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://kz.wingie.com/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://kz.wingie.com/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://kz.wingie.com/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://kz.wingie.com/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://kz.wingie.com/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://kz.wingie.com/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://kz.wingie.com/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://kz.wingie.com/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'kz-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://kz.wingie.com/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://kz.wingie.com/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://kz.wingie.com/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://kz.wingie.com/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://kz.wingie.com/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://kz.wingie.com/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://kz.wingie.com/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://kz.wingie.com/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://kz.wingie.com/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://kz.wingie.com/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://kz.wingie.com/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://kz.wingie.com/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://kz.wingie.com/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://kz.wingie.com/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://kz.wingie.com/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://kz.wingie.com/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://kz.wingie.com/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://kz.wingie.com/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}